import React,{Fragment} from 'react'
import { Select,Button, Input,Icon } from 'semantic-ui-react'
import {useMediaQuery,useTheme, Typography} from '@material-ui/core';



function Search(props) {
    const theme = useTheme()

    const ismatch = useMediaQuery(theme.breakpoints.up("sm"))

    const options=[
        { key : '0',value : 'a',text: 'CA and Accounting' },
        { key : '1',value : 'b',text: 'Data Science' },
        { key : '2',value : 'c',text: 'Designing and Drafting' },
        { key : '3',value : 'd',text: 'Digital Marketing' },
        { key : '4',value : 'e',text: 'Engineering' },
        { key : '5',value : 'f',text: 'Event Management' },
        { key : '6',value : 'g',text: 'Food and Catering' },
        { key : '7',value : 'h',text: 'Freelancing' },
        { key : '8',value : 'i',text: 'Graphic Designing' },
        { key : '9',value : 'j',text: 'Human Resources'},
        { key : '10',value : 'k',text: 'Interior Designing'},
        { key : '11',value : 'l',text: 'Machining'},
        { key : '12',value : 'm',text: 'Production Man Power'},
        { key : '13',value : 'n',text: 'Tools and Materials'},
        { key : '14',value : 'o',text: 'Web Development'},
    ]

    return (
        <div className="container mb-5">
            {
                (ismatch ) ? 
                <Fragment>
                <Typography align="center" className="mb-2" color="textSecondary" variant="h4">
                    Vendor Account Verification
                </Typography>
                <Typography align="center" variant="body2" className="mb-4">
                    An otp will be sent to the registered vendor email address for verification.
                </Typography>
                </Fragment>
                :
                <Fragment>
                <Typography align="center" className="mb-2" color="textSecondary" variant="h5">
                    Vendor Account Verification
                </Typography>
                <Typography align="center" variant="body2" className="mb-4">
                    An otp will be sent to the registered vendor email address for verification.
                </Typography>
                </Fragment>
            }
             
                {
                    (ismatch) ? 
                    <div align="center">
                        <div style={{width : '70%'}}>
                        <Input value={props.values.email} name="email" fluid onChange={props.get} iconPosition='left' placeholder='email'>
                        <Icon name='at' />
                        <input />
                    </Input>
                    {
                        props.values.msg ? 
                        <Typography variant="body2" color="secondary">
                            {props.values.msg}        
                      </Typography>   : ''
                    }
                  
                   </div>
                    <br/>
                    
                    <Select  
                    options={options} 
                    onChange={props.dropdown} 
                    style={{width : '40%'}} 
                    placeholder="Select services"
                    />

                    {
                        props.values.msg ? 
                        <Typography variant="body2" color="secondary">
                            {props.values.msg}        
                      </Typography>   : ''
                    }
                    <br/><br/>
                    {
                        (props.values.data === null || props.values.data==="") ? 
                        <Typography variant="subtitle1" color="secondary">
                        Both the fields are mandatory*        
                        </Typography> 
                        :
                        <Fragment> 
                        <Input onChange={props.getOtp} placeholder='Enter otp' />
                        { 
                        ( props.values.otpmsg) ? 
                        <Typography variant="subtitle1" color="secondary">
                        Invalid otp
                        </Typography> 
                        :
                        props.values.otpmsg==='' ?
                        <Typography variant="subtitle2" color="textSecondary">
                            Scroll down to edit your details.
                        </Typography>
                        :
                        ""
                        }
                        <Button onClick={props.confirm} content='confirm otp' style={{margin : '1rem auto'}} size="tiny" color="green"></Button>    
                        </Fragment>
                    }

                    {
                    props.loading ? 
                    <Button loading content='Search' style={{margin : '1rem auto'}} size="tiny" primary />
                    :
                    <Button onClick={props.submit} content='Search' style={{margin : '1rem auto'}} size="tiny" primary />
                    }   
                    </div>   
                           
                    :
                    <div align="center">
                        <div style={{width : '85%'}}>
                        <Input value={props.values.email} name="email" fluid onChange={props.get} iconPosition='left' placeholder='email'>
                        <Icon name='at' />
                        <input />
                    </Input>
                    {
                        props.values.msg ? 
                        <Typography variant="body2" color="secondary">
                            {props.values.msg}        
                      </Typography>   : ''
                    }
                  
                   </div>
                    <br/>
                    
                    <Select  
                    options={options} 
                    onChange={props.dropdown} 
                    style={{width : '85%'}} 
                    placeholder="Select services"
                    />

                    {
                        props.values.msg ? 
                        <Typography variant="body2" color="secondary">
                            {props.values.msg}        
                      </Typography>   : ''
                    }
                    <br/><br/>
                    {
                        (props.values.data === null || props.values.data==="") ? 
                        <Typography variant="subtitle1" color="secondary">
                        Both the fields are mandatory*        
                        </Typography> 
                        :
                        <Fragment> 
                        <Input onChange={props.getOtp} placeholder='Enter otp' />
                        { 
                       ( props.values.otpmsg) ? 
                       <Typography variant="subtitle1" color="secondary">
                       Invalid otp
                       </Typography> 
                       :
                       props.values.otpmsg==='' ?
                       <Typography variant="subtitle2" color="textSecondary">
                           Scroll down to edit your details.
                       </Typography>
                       :
                       "" 
                        }
                        <Button onClick={props.confirm} content='confirm otp' style={{margin : '1rem auto'}} size="tiny" color="green"></Button>    
                        </Fragment>
                    }

                    {
                    props.loading ? 
                    <Button loading content='Search' style={{margin : '1rem auto'}} size="tiny" primary />
                    :
                    <Button onClick={props.submit} content='Search' style={{margin : '1rem auto'}} size="tiny" primary />
                    }   
                    </div>   
                  
                }
                <hr/>
                {
                (props.values.data=== "") ?
                "" : 
                (props.values.data ===null) ? 
                <Typography align="center" variant="subtitle1" color="textSecondary">
                 No results found 
                </Typography>
                :
                ""
            }
        </div>

    )
}

export default Search
